import { createContext, useContext, useState } from "react";

export const ContractorContext = createContext(null);

export const ContractorProvider = ({ children }) => {
    const [contractorId, setContractorIdState] = useState(
        () => localStorage.getItem("contractorId") || ""
    );

    const setContractorId = (id) => {
        localStorage.setItem("contractorId", id);
        setContractorIdState(id);
    };

    const clearContractorId = () => {
        localStorage.removeItem("contractorId");
        setContractorIdState("");
    };

    return (
        <ContractorContext.Provider value={{ contractorId, setContractorId, clearContractorId }}>
            {children}
        </ContractorContext.Provider>
    );
};

export const useContractor = () => useContext(ContractorContext);

export default ContractorProvider;
